<template>
  <div
    id="comic-controlls"
    :style="{
      width: 'calc(1080px * 0.1)',
      height: 'calc(1080px * 0.05)',
      top: itemStyle.top + '%',
      left: itemStyle.left + '%',
      position: 'relative',
    }"
  >
    <svg
      class="audioIcon"
      viewBox="0 0 24 24"
      width="calc(1080px * 0.05)"
      height="calc(1080px * 0.05)"
      @click="playSound()"
    >
      <transition name="info-fade">
        <path
          class="showAudioFalse"
          v-if="!audioVisible"
          d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
        />
      </transition>
      <transition name="info-fade">
        <path
          class="showAudioTrue"
          v-if="audioVisible"
          d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
        />
      </transition>
    </svg>
    <svg
      class="closeIcon"
      viewBox="0 0 24 24"
      width="calc(1080px * 0.05)"
      height="calc(1080px * 0.05)"
      @click="comicInteraction()"
    >
      <path
        class="closeComic"
        fill="red"
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: 'comic-controlls',
  props: {
    itemStyle: {
      default: () => {
        return '';
      },
      type: Object,
    },
    slideName: {
      default: () => {
        return '';
      },
      type: String,
    },
  },
  data() {
    return {
      canIPlayASong: true,
      blockAnim: false,
      animated: false,
    };
  },
  methods: {
    comicInteraction() {
      this.$store.commit('STATE_COMIC_SHOW', !this.showComic);
    },
    playSound() {
      this.$store.commit('STATE_AUDIO', !this.audioVisible);
      this.$store.commit('STATE_AUDIO_WAIT', true);
      // if (this.audioVisible) {
      //   this.canIPlayASong = false;
      //   let audio = document.getElementById('audio' + this.slideName);
      //   audio.volume = .7
      //   audio.play();
      //   audio.addEventListener("ended", () => {
      //     this.canIPlayASong = true;
      //     this.$store.commit("STATE_AUDIO", false);
      //   }, true);
      // } else {
      //   this.canIPlayASong = true;
      //   this.$store.commit("STATE_AUDIO_WAIT", false);
      //   let audio = document.getElementById('audio' + this.slideName);
      //   audio.pause();
      //   audio.currentTime = 0;
      // }
    },
  },
  computed: {
    showComic() {
      return this.$store.getters.getComicShow;
    },
    currentSlide() {
      return this.$store.getters.getCurrentStep;
    },
    audioVisible() {
      return this.$store.getters.getAudio;
    },
  },
};
</script>
<style lang="sass">
@import '../../style/base'
@import '../../style/animation'
#comic-controlls
  svg
    display: inline-block
  #atomSvg
    position: absolute
    width: 90%
    left: 0
    top: 0
    height: 90%
    //transform-origin: center
  .imgAtom
    //transform-origin: center
    position: absolute
    width: 90%
    height: 90%
    left: 0
    top: 0
</style>
